import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';

import AttachmentContent from '../AttachmentContent';
import CodeContent from '../CodeContent';
import DateContent from '../DateContent';
import ImageContent from '../ImageContent';
import LongTextContent from '../LongTextContent';
import MultiSelectContent from '../MultiSelectContent';
import SingleSelectContent from '../SingleSelectContent';
import TextContent from '../TextContent';

import styles from './Cell.module.scss';
import usePresenter from './Cell.presenter';
import getProps from './Cell.props';
import { CellCombinedProps } from './types';


// MANUAL OVERRIDE - converted to observer Component
const Cell: React.FC<CellCombinedProps> = observer((props) => {
  const {
    type,
    className,
    classes,
    attachmentContent,
    dateContent,
    imageContent,
    codeContent,
    longTextContent,
    multiSelectContent,
    textContent,
    singleSelectContent,
  } = usePresenter(props);

  const variantName = `${type}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`cell${variantName}`];

  let componentView;

  switch (variantName) {
    case 'Attachment': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <AttachmentContent
            className={cx(styles.attachmentContent, classes?.attachmentContent)}
            {...internalProps.attachmentContent}
            {...attachmentContent}
          />
        </div>
      );
      break;
    }
    case 'Date': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <DateContent
            className={cx(styles.dateContent, classes?.dateContent)}
            {...internalProps.dateContent}
            {...dateContent}
          />
        </div>
      );
      break;
    }
    case 'Image': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <ImageContent
            className={cx(styles.imageContent, classes?.imageContent)}
            {...internalProps.imageContent}
            {...imageContent}
          />
        </div>
      );
      break;
    }
    case 'JSON': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <CodeContent
            className={cx(styles.codeContent, classes?.codeContent)}
            {...internalProps.codeContent}
            {...codeContent}
          />
        </div>
      );
      break;
    }
    case 'LongText': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <LongTextContent
            className={cx(styles.longTextContent, classes?.longTextContent)}
            {...internalProps.longTextContent}
            {...longTextContent}
          />
        </div>
      );
      break;
    }
    case 'MultiReference':
    case 'MultiSelect': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <MultiSelectContent
            className={cx(styles.multiSelectContent, classes?.multiSelectContent)}
            {...internalProps.multiSelectContent}
            {...multiSelectContent}
          />
        </div>
      );
      break;
    }
    case 'Number':
    case 'ShortText': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <TextContent
            className={cx(styles.textContent, classes?.textContent)}
            {...internalProps.textContent}
            {...textContent}
          />
        </div>
      );
      break;
    }
    case 'SingleReference':
    case 'SingleSelect': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <SingleSelectContent
            className={cx(styles.singleSelectContent, classes?.singleSelectContent)}
            {...internalProps.singleSelectContent}
            {...singleSelectContent}
          />
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
}); // MANUAL OVERRIDE

export default Cell;
